module.exports = __webpack_public_path__ + "static/media/sheets_download.88e2407b.svg";